import { render } from "./LabelStockDetailPage.vue?vue&type=template&id=1feb9fa4&scoped=true"
import script from "./LabelStockDetailPage.vue?vue&type=script&lang=js"
export * from "./LabelStockDetailPage.vue?vue&type=script&lang=js"

import "./LabelStockDetailPage.vue?vue&type=style&index=0&id=1feb9fa4&scoped=true&lang=css"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1feb9fa4"]])

export default __exports__